jQuery(document).ready(function ($) {
    $('.history__year').on('click', function (event) {
        if ($(this).attr('data-active')) return;

        $('.history__year').removeAttr('data-active');
        $(this).attr('data-active', '');
    });

    $('.history__year--next').on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        const $current = $(this).closest('.history__year');
        let $next = $current.next('.history__year');

        if (!$next.length) {
            $next = $current.siblings('.history__year').first();
        }

        $current.removeAttr('data-active');
        $next.attr('data-active', '');
    });
});